export default function initItemsScrollDown(): void {
    const $itemsScrollDownContainer = document.querySelectorAll('.js-block-items-scroll-down');

    $itemsScrollDownContainer.forEach($container => {
        new ItemsScrollDown($container as HTMLElement);
    });
}

class ItemsScrollDown {
    $el: HTMLElement;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        const $accordeons = this.$el.querySelectorAll('.accordeon') as NodeListOf<HTMLDetailsElement>;

        const openFirstAccordeon = () => {
            if ($accordeons.length > 0) {
                $accordeons[0].open = true;
            }
        };

        const closeAllAccordeonExceptTheCurrent = () => {
            const $accordeonButtons = this.$el.querySelectorAll('.accordeon-title');

            $accordeonButtons.forEach(button => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();

                    const $target = event.currentTarget as HTMLElement;
                    const $parent = $target.closest('.accordeon') as HTMLDetailsElement | null;
                    if (!$parent) return;

                    $accordeons.forEach(accordeon => {
                        if (accordeon !== $parent) {
                            accordeon.open = false;
                        }
                    });

                    $parent.open = !$parent.open;
                });
            });
        };

        const moveScreenToAccordeon = () => {
            const $accordeonButtons = this.$el.querySelectorAll('.accordeon-title');
            const $nav = document.querySelector('.navigation') as HTMLElement;
        
            const handleScrollToAccordeon = () => {
                if (window.innerWidth <= 1040) {
                    $accordeonButtons.forEach(button => {
                        button.addEventListener('click', () => {
                            const accordeonPosition = button.getBoundingClientRect();
                            const navHeight = $nav ? $nav.offsetHeight : 0;
                            window.scrollTo({top: accordeonPosition.top + window.scrollY - navHeight - 50, behavior: 'smooth'});
                        })
                    });
                }
            };
            
            window.addEventListener('resize', handleScrollToAccordeon);
            window.addEventListener('load', handleScrollToAccordeon);
        }

        openFirstAccordeon();
        closeAllAccordeonExceptTheCurrent();
        moveScreenToAccordeon();
    }
}